import React, { useEffect, useState } from "react";
import { api, CAD, COMMISSION_STATUSES, fmtDate } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { useNavigate } from "react-router-dom";

export default function Commissions() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("all");
  const [err, setErr] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get(`/commissions`).then(r=>setRows(r.data)).catch(e=>setErr(e.response?.data?.detail||"Access denied")); }, []);

  const filtered = rows.filter(r => status === "all" || r.status === status);
  const totals = filtered.reduce((acc, r) => {
    acc.expected += r.expected_commission||0;
    acc.received += r.commission_amount_received||0;
    acc.partnerPay += r.partner_commission_payable||0;
    acc.partnerPaid += r.partner_amount_paid||0;
    acc.net += r.company_net||0;
    return acc;
  }, {expected:0, received:0, partnerPay:0, partnerPaid:0, net:0});

  if (err) return <div className="bg-white p-6 rounded-xl border border-slate-200 text-slate-500">{err}</div>;

  return (
    <div className="space-y-6">
      <div><h1 className="heading-font text-3xl font-bold text-slate-900">Commissions</h1><p className="text-sm text-slate-500 mt-1">Track invoices, receipts, and partner payouts (CAD).</p></div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {[["Expected", totals.expected], ["Received", totals.received], ["Partner Payable", totals.partnerPay], ["Partner Paid", totals.partnerPaid], ["Company Net", totals.net]].map(([l, v]) => (
          <div key={l} className="bg-white rounded-xl border border-slate-200 p-4">
            <div className="text-xs uppercase text-slate-500">{l}</div>
            <div className="heading-font text-xl font-bold text-slate-900 mono mt-1">{CAD(v)}</div>
          </div>
        ))}
      </div>
      <div className="bg-white p-3 rounded-xl border border-slate-200 flex gap-2 items-center">
        <span className="text-xs uppercase text-slate-500 pl-1">Status</span>
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger data-testid="comm-status-filter" className="w-64 h-9 bg-white"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All</SelectItem>{COMMISSION_STATUSES.map(s=><SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
            <tr><th className="text-left px-4 py-3">Student</th><th className="text-left px-4 py-3">Period</th><th className="text-left px-4 py-3">Expected</th><th className="text-left px-4 py-3">Received</th><th className="text-left px-4 py-3">Net</th><th className="text-left px-4 py-3">Status</th></tr>
          </thead>
          <tbody>
            {filtered.map(r => (
              <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50 cursor-pointer" onClick={()=>r.application && nav(`/applications/${r.application.id}`)}>
                <td className="px-4 py-3 font-medium">{r.application?.student_name}<div className="text-xs text-slate-500 mono">{r.application?.application_id}</div></td>
                <td className="px-4 py-3">{r.semester_period}</td>
                <td className="px-4 py-3 mono">{CAD(r.expected_commission)}</td>
                <td className="px-4 py-3 mono">{CAD(r.commission_amount_received)}</td>
                <td className="px-4 py-3 mono font-semibold">{CAD(r.company_net)}</td>
                <td className="px-4 py-3"><span className="stage-badge bg-teal-50 text-teal-900 border-teal-300">{r.status}</span></td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={6} className="text-center py-10 text-slate-500">No commission records.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
